import React from 'react';

import classes from './styles.module.scss';

export default function Role({ role }) {
  return <div className={classes.Role}>{role}</div>;
}
